import onelps from '../../api';

export const verifyUserIdentifier = async function(locale, identifier, dispatchFn) {
	try {
		const result = await onelps.actions.passwordForgottenVerify({ playerIdentification: identifier }, locale);

		return result;
	}
	catch(e) {
		dispatchFn({ type: 'SHOW_SERVER_ERROR' });
	}
};